export const isValueOfObject = <T extends object>(
    value: string | null,
    obj: T
): boolean => {
    return typeof value === 'string' && Object.values(obj).includes(value);
};

export const isKeyOfObject = <T extends object>(
    value: string | null,
    obj: T
): boolean => {
    return typeof value === 'string' && value in obj;
};
